import React from "react";
import {
  Container,
  HeaderSection,
  Title,
  LastUpdated,
  Content,
  Section,
  SectionTitle,
  SectionContent,
  List,
  ListItem,
  ContactBox,
  ContactLink,
  AcceptanceBox,
} from "./TermsOfService.style";

export default function TermsOfService() {
  React.useEffect(() => {
    document.title = "Terms of Service — TrixieGroup & Association";
    window.scrollTo(0, 0);
  }, []);

  return (
    <Container>
      <HeaderSection>
        <Title>Terms of Service</Title>
        <LastUpdated>Last Updated: April 2, 2026</LastUpdated>
      </HeaderSection>

      <AcceptanceBox>
        <strong>Please read these Terms of Service carefully.</strong> By accessing or
        using our website and services, you agree to be bound by these terms and
        conditions. If you do not agree to all the terms and conditions, then you
        may not access the website or use any services.
      </AcceptanceBox>

      <Content>
        <Section>
          <SectionTitle>1. Agreement to Terms</SectionTitle>
          <SectionContent>
            These Terms of Service constitute a legally binding agreement made between
            you and TrixieGroup & Association ("we," "us," or "our"), concerning your
            access to and use of our website and services. You agree that by accessing
            the Site, you have read, understood, and agree to be bound by all of these
            Terms of Service.
          </SectionContent>
        </Section>

        <Section>
          <SectionTitle>2. Services</SectionTitle>
          <SectionContent>
            TrixieGroup & Association provides security technology solutions and solar
            energy services, including but not limited to:
          </SectionContent>
          <List>
            <ListItem>CCTV surveillance system installation and maintenance</ListItem>
            <ListItem>Solar inverter sales and installation</ListItem>
            <ListItem>Solar panel system design and deployment</ListItem>
            <ListItem>Security consulting and assessment</ListItem>
            <ListItem>Technical support and maintenance services</ListItem>
          </List>
        </Section>

        <Section>
          <SectionTitle>3. Intellectual Property Rights</SectionTitle>
          <SectionContent>
            Unless otherwise indicated, the Site is our proprietary property and all
            source code, databases, functionality, software, website designs, audio,
            video, text, photographs, and graphics on the Site and the trademarks,
            service marks, and logos contained therein are owned or controlled by us
            or licensed to us, and are protected by copyright and trademark laws.
          </SectionContent>
          <SectionContent>
            Provided that you are eligible to use the Site, you are granted a limited
            license to access and use the Site and to download or print a copy of any
            portion of the content to which you have properly gained access solely for
            your personal, non-commercial use.
          </SectionContent>
        </Section>

        <Section>
          <SectionTitle>4. User Representations</SectionTitle>
          <SectionContent>
            By using the Site, you represent and warrant that:
          </SectionContent>
          <List>
            <ListItem>All registration information you submit will be true, accurate, current, and complete</ListItem>
            <ListItem>You will maintain the accuracy of such information and promptly update it as necessary</ListItem>
            <ListItem>You have the legal capacity and agree to comply with these Terms of Service</ListItem>
            <ListItem>You will not access the Site through automated or non-human means</ListItem>
            <ListItem>You will not use the Site for any illegal or unauthorized purpose</ListItem>
          </List>
        </Section>

        <Section>
          <SectionTitle>5. Service Quotes and Contracts</SectionTitle>
          <SectionContent>
            All service quotes provided through our Site are estimates based on information
            provided by you. Final pricing may vary based on site inspection and specific
            requirements. A binding contract is only formed when:
          </SectionContent>
          <List>
            <ListItem>A written agreement is signed by both parties</ListItem>
            <ListItem>A deposit or full payment is received as specified in the agreement</ListItem>
            <ListItem>The scope of work has been clearly defined and accepted</ListItem>
          </List>
        </Section>

        <Section>
          <SectionTitle>6. Payment Terms</SectionTitle>
          <SectionContent>
            Payment terms for our services are as follows:
          </SectionContent>
          <List>
            <ListItem>A deposit may be required before work commencement</ListItem>
            <ListItem>Payment schedules will be outlined in your service agreement</ListItem>
            <ListItem>Late payments may incur interest charges as permitted by law</ListItem>
            <ListItem>All prices are in Nigerian Naira (NGN) unless otherwise stated</ListItem>
          </List>
        </Section>

        <Section>
          <SectionTitle>7. Warranty and Guarantees</SectionTitle>
          <SectionContent>
            We stand behind the quality of our work with the following warranties:
          </SectionContent>
          <List>
            <ListItem>Solar panel installations: 25 years performance warranty (manufacturer)</ListItem>
            <ListItem>Inverter systems: 5-10 years warranty depending on manufacturer</ListItem>
            <ListItem>Installation workmanship: 2 years warranty</ListItem>
            <ListItem>CCTV equipment: As per manufacturer warranty terms</ListItem>
          </List>
          <SectionContent>
            Warranties do not cover damage caused by misuse, unauthorized modifications,
            natural disasters, or failure to follow maintenance guidelines.
          </SectionContent>
        </Section>

        <Section>
          <SectionTitle>8. Limitation of Liability</SectionTitle>
          <SectionContent>
            In no event shall we or our directors, employees, or agents be liable to
            you or any third party for any direct, indirect, consequential, exemplary,
            incidental, special, or punitive damages, including lost profit, lost revenue,
            loss of data, or other damages arising from your use of the site or our
            services. Notwithstanding anything to the contrary contained herein, our
            liability to you for any cause whatsoever and regardless of the form of
            the action, will at all times be limited to the amount paid, if any, by
            you to us during the six (6) month period prior to any cause of action arising.
          </SectionContent>
        </Section>

        <Section>
          <SectionTitle>9. Governing Law</SectionTitle>
          <SectionContent>
            These Terms shall be governed by and defined following the laws of the
            Federal Republic of Nigeria. TrixieGroup & Association and yourself irrevocably
            consent that the courts of Nigeria shall have exclusive jurisdiction to
            resolve any dispute which may arise in connection with these terms.
          </SectionContent>
        </Section>

        <Section>
          <SectionTitle>10. Changes to Terms</SectionTitle>
          <SectionContent>
            We reserve the right, in our sole discretion, to make changes or modifications
            to these Terms of Service at any time and for any reason. We will alert
            you about any changes by updating the "Last Updated" date of these Terms
            of Service. Any changes or modifications will be effective immediately
            upon posting the updated Terms of Service on the Site.
          </SectionContent>
        </Section>

        <Section>
          <SectionTitle>11. Contact Us</SectionTitle>
          <SectionContent>
            If you have any questions about these Terms of Service, please contact us:
          </SectionContent>
          <ContactBox>
            <p><strong>TrixieGroup & Association</strong></p>
            <p>Ise Eledumare Shopping Complex,<br />Okebola off Iyana Ogunpa Road, Ibadan, Nigeria</p>
            <ContactLink href="tel:+2348034231676">+234 803 423 1676</ContactLink>
            <ContactLink href="mailto:info@trixiegroup.com">info@trixiegroup.com</ContactLink>
          </ContactBox>
        </Section>
      </Content>
    </Container>
  );
}
